module.exports = __webpack_public_path__ + "img/filter-type-new--active.a09d7e20.svg";